import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { useDirectedVideoContext } from '../../DirectedVideoContext';
import { directedMessages } from '../../messages/directedMessages';
import { directorMessages as messages } from '../../messages/directorMessages';
import { useDirectedCastNames } from '../../useDirectedCastNames';
import { SectionMapBar } from '../../shell/SectionMapBar';
import { DirectorRuns } from './DirectorRuns';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the director steps; each part uses its own slice of it */
import styles from '../DirectorSteps.module.scss';
/* eslint-enable css-modules/no-unused-class */
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the directed video; each part uses its own slice of it */
import shell from '../../DirectedVideo.module.scss';
/* eslint-enable css-modules/no-unused-class */

/**
 * The side panel of the story and the style steps (design DvSide): the cast, the picked story and
 * style, the sections, the director runs left and the note that nothing costs before the price.
 */
const DirectedSummaryComponent: React.FC = () => {
  const intl = useIntl();
  const { named } = useDirectedCastNames();
  const { video, song } = useDirectedVideoContext();
  return (
    <>
      <h4>{intl.formatMessage(messages.sideTitle)}</h4>
      <div className={styles.summary}>
        <span className={styles.summaryEyebrow}>
          {intl.formatMessage(messages.sideCast, { count: video.cast.length })}
        </span>
        {video.cast.length === 0 ? (
          <p className={styles.summaryText}>{intl.formatMessage(messages.sideNoCast)}</p>
        ) : (
          <div className={styles.castChips}>
            {video.cast.map((entry) => (
              <span key={entry.id} className={styles.castChip}>
                {entry.url === '' ? <i aria-hidden /> : <img src={entry.url} alt="" />}
                {entry.label}
              </span>
            ))}
          </div>
        )}
      </div>
      {video.story !== null && (
        <div className={styles.summary}>
          <span className={styles.summaryEyebrow}>{intl.formatMessage(messages.sideStory)}</span>
          <span className={styles.summaryTitle}>{named(video.story.title)}</span>
          <p className={styles.summaryText}>{named(video.story.logline)}</p>
        </div>
      )}
      {video.style !== null && (
        <div className={styles.summary}>
          <span className={styles.summaryEyebrow}>{intl.formatMessage(messages.sideStyle)}</span>
          <span className={styles.summaryTitle}>{named(video.style.title)}</span>
          <p className={styles.summaryText}>
            {[video.style.camera, video.style.colourAndLight, video.style.texture]
              .filter((line) => line !== '')
              .join(', ')}
          </p>
        </div>
      )}
      {song.sections.length > 0 && (
        <>
          <span className={shell.eyebrow}>{intl.formatMessage(directedMessages.sections)}</span>
          <SectionMapBar sections={song.sections} />
        </>
      )}
      <span className={shell.grow} />
      <DirectorRuns left={video.directorRunsLeft} />
      <p className={shell.hint}>{intl.formatMessage(directedMessages.sideHint)}</p>
    </>
  );
};

export const DirectedSummary = TypedMemo(DirectedSummaryComponent);
